import { put, takeEvery } from 'redux-saga/effects';
import { requestLeaderBoard } from './api';
import { LEADER_BOARD } from './constants';
import { leaderBoardSuccess } from './actions';

/**
 *
 * @param obj
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{result: *, type: string}>>|*, void, *>}
 */
function* getLeaderBoard( obj ) {
    const serverResponse = yield requestLeaderBoard( obj.id );
    if ( serverResponse ) {
        yield put( leaderBoardSuccess( serverResponse ) );
    }
}

/**
 *
 * @returns {Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>}
 */
function* watchLeaderBoard() {
    yield takeEvery( LEADER_BOARD, getLeaderBoard );
}

export default watchLeaderBoard;
